/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { whatsAppAiThreadStateDataActivityStateSchema } from './WhatsAppAiThreadStateDataActivityStateSchema'

export const whatsAppAiThreadStateDataSchema = z.object({
	status: z.string().nullable(),
	activityState: whatsAppAiThreadStateDataActivityStateSchema.nullable(),
	activitySince: z.string().nullable(),
	summary: z.string().nullable(),
})

export type WhatsAppAiThreadStateDataSchema = z.infer<typeof whatsAppAiThreadStateDataSchema>
